<script lang="ts">
	export let fill = "#6d6f76";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 26 26">
	<path
		data-name="패스 20801"
		d="M761.481 278.005a13 13 0 1 0 13 13 13 13 0 0 0-13-13zm8.418 7.272-7.986 7.412a.519.519 0 0 1-.686.019l-5.4-4.481a.52.52 0 0 1 .665-.8l5.05 4.19 7.651-7.1a.52.52 0 0 1 .708.762z"
		transform="translate(-748.481 -278.005)"
		fill={fill} />
</svg>

<style lang="scss">
</style>
